import { SelectOption } from '@web-for-marketing/react-ui';

const canadianProvinceOptions: SelectOption[] = [
    { value: 'AB', content: 'Alberta' },
    { value: 'BC', content: 'British Columbia' },
    { value: 'MB', content: 'Manitoba' },
    { value: 'NB', content: 'New Brunswick' },
    { value: 'NL', content: 'Newfoundland and Labrador' },
    { value: 'NT', content: 'Northwest Territories' },
    { value: 'NS', content: 'Nova Scotia' },
    { value: 'NU', content: 'Nunavut' },
    { value: 'ON', content: 'Ontario' },
    { value: 'PE', content: 'Prince Edward Island' },
    { value: 'QC', content: 'Quebec' },
    { value: 'SK', content: 'Saskatchewan' },
    { value: 'YT', content: 'Yukon Territories' },
];

export default canadianProvinceOptions;
